import { SKILL_TEST_EXPIRY_BUSINESS_DAYS } from '../ContestSkillTest/skillTestUtils';

export const HERO_PARTICLES: Array<{
  tone: 'gold' | 'white' | 'ice';
  top: string;
  left: string;
  width: number;
  height: number;
  delay: string;
  duration: string;
}> = [
  { tone: 'gold', top: '14%', left: '8%', width: 5, height: 5, delay: '0s', duration: '7s' },
  { tone: 'white', top: '28%', left: '18%', width: 3, height: 3, delay: '1.4s', duration: '9s' },
  { tone: 'gold', top: '68%', left: '6%', width: 4, height: 4, delay: '2.8s', duration: '8s' },
  { tone: 'ice', top: '44%', left: '30%', width: 3, height: 3, delay: '.7s', duration: '10s' },
  { tone: 'gold', top: '80%', left: '22%', width: 5, height: 5, delay: '3.5s', duration: '7.5s' },
  { tone: 'white', top: '18%', left: '52%', width: 3, height: 3, delay: '2.1s', duration: '11s' },
  { tone: 'gold', top: '55%', left: '46%', width: 4, height: 4, delay: '4.2s', duration: '8.5s' },
  { tone: 'ice', top: '34%', left: '62%', width: 3, height: 3, delay: '1.0s', duration: '9.5s' },
  { tone: 'gold', top: '72%', left: '58%', width: 5, height: 5, delay: '3.0s', duration: '7s' },
  { tone: 'white', top: '12%', left: '72%', width: 3, height: 3, delay: '.4s', duration: '10.5s' },
  { tone: 'gold', top: '88%', left: '70%', width: 4, height: 4, delay: '2.5s', duration: '8s' },
];

export type ProgramRule = {
  keyPhrases: string[];
  text: string;
};

export const PROGRAM_RULES: ProgramRule[] = [
  {
    keyPhrases: ['No purchase necessary', 'free entry method'],
    text: 'No purchase necessary. You can earn tickets and enter without paying: a free entry method is available in the app, with the same chance of winning as everyone else.',
  },
  {
    keyPhrases: ['residents of Canada', 'active TenantPay account'],
    text: 'Open to residents of Canada who have reached the age of majority in their province or territory and hold an active TenantPay account. Void where prohibited.',
  },
  {
    keyPhrases: ['qualifying activity', '$500 minimum'],
    text: 'Earn tickets through qualifying activity each month. (A $500 minimum applies only to certain rent-payment reward actions, never to entering the drop or receiving a credit.)',
  },
  {
    keyPhrases: ['1st to the last day of each month', '11:59 PM ET'],
    text: 'The drop runs from the 1st to the last day of each month, closing at 11:59 PM ET; tickets are entered automatically at close.',
  },
  {
    keyPhrases: ['selected at random', 'One rent credit per member per month'],
    text: 'Winners are selected at random from all eligible tickets. Every ticket has an equal chance; more tickets mean more chances. One rent credit per member per month.',
  },
  {
    keyPhrases: ['Odds depend on the number of eligible tickets'],
    text: 'Odds depend on the number of eligible tickets that month (credits available ÷ total eligible tickets); the live ticket count is shown in the app.',
  },
  {
    keyPhrases: ['skill-testing question', `${SKILL_TEST_EXPIRY_BUSINESS_DAYS} business days`],
    text: `To claim, you must correctly answer a skill-testing question within ${SKILL_TEST_EXPIRY_BUSINESS_DAYS} business days and confirm your details electronically.`,
  },
  {
    keyPhrases: ['no cash value', "can't be transferred", 'following month'],
    text: 'Rent credits apply to your rent through TenantPay, have no cash value, can\'t be transferred, and are applied to the following month.',
  },
  {
    keyPhrases: ['reset to zero', '12 months of account inactivity'],
    text: 'Tickets reset to zero after each monthly draw and don\'t carry forward. Points expire after 12 months of account inactivity (with advance notice).',
  },
  {
    keyPhrases: ['suspicious activity', 'disqualification'],
    text: 'Any suspicious activity or breach of these rules can result in disqualification.',
  },
];

export const PDR_AVATAR_COLORS = [
  '#7c3aed',
  '#3730a3',
  '#1e293b',
  '#c026d3',
  '#1e293b',
  '#1e293b',
  '#1e293b',
  '#1e293b',
  '#1e3a5f',
] as const;
